<div class="marketing-opt-in" *ngIf="elementName === 'email'">
  <div class="terms-notice">
    <input
      type="checkbox"
      name="email_opt_in"
      class="opt-in-checkbox"
      [(ngModel)]="userProfile.email_opt_in"
      (ngModelChange)="userProfileChange.emit(userProfile)"
    />
    <p>I agree to receive emails about {{ tenantName }} news and offers</p>
  </div>
  <div class="terms-agreement-text">
    By checking this box, you are authorizing {{ tenantName }} and its service providers or
    affiliates to contact you at the email address that you provided above about future products or
    services. To opt out of future marketing and advertising at any time [or view your profile
    settings], visit
    <span class="tnc-pp-span tertiary-button" (click)="onTermsClick(privacyPolicy)"
      >opt-out instructions</span
    >. Visit our
    <span class="tnc-pp-span tertiary-button" (click)="onTermsClick(privacyPolicy)"
      >privacy policy</span
    >
    to learn about our information practices and your privacy rights.
  </div>
</div>
<div class="marketing-opt-in" *ngIf="elementName === 'sms'">
  <div class="terms-notice">
    <input
    type="checkbox"
    name="sms_opt_in"
    class="opt-in-checkbox"
    [(ngModel)]="userProfile.sms_opt_in"
    (ngModelChange)="userProfileChange.emit(userProfile)"
  />
    <p>I agree to receive texts about {{ tenantName }} news and offers</p>
  </div>
  <div class="terms-agreement-text">
    By checking this box, you are authorizing {{ tenantName }} and its service providers or
    affiliates to contact you via text (SMS) at the phone number that you provided above using
    automated dialing technology for marketing purposes. This is not a condition for purchase.
    Message and data rates may apply. To opt out at any time reply "STOP" to any
    {{ tenantName }} SMS or visit
    <span class="tnc-pp-span tertiary-button" (click)="onTermsClick(privacyPolicy)"
      >opt-out instructions</span
    >. Visit our
    <span class="tnc-pp-span tertiary-button" (click)="onTermsClick(privacyPolicy)"
      >privacy policy</span
    >
    to learn about our information practices and your privacy rights.
  </div>
</div>

